import React, { useState } from "react";
import "../../Styles/JanataDarbarForm.css";

const AdminJanataDarbarForm = () => {
  const [formData, setFormData] = useState({
    token: "",
    name: "",
    mobile: "",
    age: "",
    gender: "",
    category: "",
    village: "",
    mandal: "",
    date: "",
    issueDescription: "",
    actionTaken: "",
    status: "",
    photo: null,
  });

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    setFormData({
      ...formData,
      [name]: files ? files[0] : value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(formData);
  };

  return (
    <div className="darbar-form-container">
      <div className="darbar-form-card">
        <div className="darbar-form-header">
          <h2>Add New Janata Darbar Visitor</h2>
          <p>Log citizen grievances and issues raised during public hearings</p>
          <button
            className="darbar-back-btn"
            onClick={() => window.history.back()}
          >
            Back
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="darbar-form-grid">

            <div className="darbar-form-group">
              <label>Token Number *</label>
              <input
                type="text"
                name="token"
                placeholder="Ex: JD-0451"
                onChange={handleChange}
              />
            </div>

            <div className="darbar-form-group">
              <label>Visitor Name *</label>
              <input
                type="text"
                name="name"
                placeholder="Enter Visitor Name"
                onChange={handleChange}
              />
            </div>

            <div className="darbar-form-group">
              <label>Mobile Number *</label>
              <input
                type="tel"
                name="mobile"
                placeholder="Enter Mobile Number"
                maxLength="10"
                onChange={handleChange}
              />
            </div>

            <div className="darbar-form-group">
              <label>Age</label>
              <input
                type="number"
                name="age"
                placeholder="Enter Age"
                onChange={handleChange}
              />
            </div>

            <div className="darbar-form-group">
              <label>Gender</label>
              <select name="gender" onChange={handleChange}>
                <option>Select Gender</option>
                <option>Male</option>
                <option>Female</option>
                <option>Other</option>
              </select>
            </div>

            <div className="darbar-form-group">
              <label>Issue Category *</label>
              <select name="category" onChange={handleChange}>
                <option>Select Category</option>
                <option>Land Dispute</option>
                <option>Pension</option>
                <option>Financial Aid</option>
                <option>Employment</option>
                <option>Health</option>
                <option>Police Matter</option>
                <option>Personal</option>
                <option>Other</option>
              </select>
            </div>

            <div className="darbar-form-group">
              <label>Village *</label>
              <input
                type="text"
                name="village"
                placeholder="Enter Village"
                onChange={handleChange}
              />
            </div>

            <div className="darbar-form-group">
              <label>Mandal *</label>
              <select name="mandal" onChange={handleChange}>
                <option>Select Mandal</option>
                <option>Kandukur</option>
                <option>Gudluru</option>
                <option>Ulavapadu</option>
              </select>
            </div>

            <div className="darbar-form-group">
              <label>Visit Date *</label>
              <input
                type="date"
                name="date"
                onChange={handleChange}
              />
            </div>

            <div className="darbar-form-group">
              <label>Status *</label>
              <select name="status" onChange={handleChange}>
                <option>Select Status</option>
                <option>Resolved</option>
                <option>In Progress</option>
                <option>Pending</option>
              </select>
            </div>

            <div className="darbar-form-group">
              <label>Upload Photo / Document</label>
              <input
                type="file"
                name="photo"
                accept="image/*,.pdf"
                onChange={handleChange}
              />
            </div>

          </div>

          <div className="darbar-form-group darbar-full-width">
            <label>Issue Description *</label>
            <textarea
              rows="3"
              name="issueDescription"
              placeholder="Describe the issue raised by the visitor"
              onChange={handleChange}
            ></textarea>
          </div>

          <div className="darbar-form-group darbar-full-width">
            <label>Action Taken / Referred To</label>
            <textarea
              rows="3"
              name="actionTaken"
              placeholder="Enter action taken, department referred to, or instructions given"
              onChange={handleChange}
            ></textarea>
          </div>

          <div className="darbar-btn-group">
            <button type="submit" className="darbar-submit-btn">
              Submit
            </button>
            <button type="reset" className="darbar-reset-btn">
              Reset
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AdminJanataDarbarForm;